const routes = {
  ROUTE_PAYMENT: '/:code',
  ROUTE_SUCCESS: '/success',
  ROUTE_NOT_FOUND: '/not_found',
}

export default routes
